// extracted by mini-css-extract-plugin
export var alignBaseline = "_9-9";
export var alignCenter = "_9-5";
export var alignFlexEnd = "_9-7";
export var alignFlexStart = "_9-6";
export var alignSelfBaseline = "_9-e";
export var alignSelfCenter = "_9-a";
export var alignSelfFlexEnd = "_9-c";
export var alignSelfFlexStart = "_9-b";
export var alignSelfStretch = "_9-d";
export var alignStretch = "_9-8";
export var column = "_9-2";
export var columnReverse = "_9-4";
export var flex = "_9-0";
export var justifyCenter = "_9-f";
export var justifyFlexEnd = "_9-h";
export var justifyFlexStart = "_9-g";
export var justifySpaceAround = "_9-j";
export var justifySpaceBetween = "_9-i";
export var justifySpaceEvenly = "_9-k";
export var row = "_9-1";
export var rowReverse = "_9-3";
export var wrapNowrap = "_9-m";
export var wrapWrap = "_9-l";
export var wrapWrapReverse = "_9-n";